import IAddressVm from "./../shared/IAddressVm"
import ICompanyVm from "./../shared/ICompanyVm"
import IServiceErrorVm from "./../home/Shared/IServiceErrorVm"
import { PaymentType } from "./../enums/PaymentType"
import { CertificateProcessType } from "./../flags/CertificateProcessType"
import { CertificateType } from "./../flags/CertificateType"

import * as IAddressVmInstance from "./../shared/IAddressVm"
import * as ICompanyVmInstance from "./../shared/ICompanyVm"

export default interface ICreateApplicationForReorderingOfCertificateVm {
    applicationId: string
    modifiedAddress: IAddressVm
    replacementApplicationId?: string
    certificateType: CertificateType
    certificateProcessType: CertificateProcessType
    errors: IServiceErrorVm[]
    selectedPaymentType: PaymentType
    companyChosenForPayment: ICompanyVm
}

export const empty = (enableIteration: boolean = true): ICreateApplicationForReorderingOfCertificateVm => {
	return {
		applicationId: "",
		modifiedAddress: IAddressVmInstance.empty(),
		replacementApplicationId: "",
		certificateType: CertificateType.NotSet,
		certificateProcessType: CertificateProcessType.NotSet,
		errors: [] as IServiceErrorVm[],
		selectedPaymentType: PaymentType.NotSet,
		companyChosenForPayment: ICompanyVmInstance.empty()
	} as ICreateApplicationForReorderingOfCertificateVm
}